// extracted by mini-css-extract-plugin
export default {"wrapper":"IndicatorList_wrapper__A9tuV"};